export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.290.0-ab3c804",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
